// RHFSelect.jsx

import React from "react";
import { Select } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFSelect = ({
  name,
  rules,
  defaultValue = null,
  data = [],
  searchable = false,
  clearable = false,
  nothingFoundMessage = "Nothing found",
  onValueChange,
  onDropdownOpen,
  onDropdownClose,
  comboboxProps,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <Select
          {...props}
          {...field}
          data={data}
          value={field.value ?? null}
          error={error?.message}
          searchable={searchable}
           styles={{
              label: {
              fontSize: "16px",lineHeight: "24px",fontWeight: 400,color: "#222222",marginBottom:'8px'
            }}}
         
          clearable={clearable}
          nothingFoundMessage={nothingFoundMessage}
          comboboxProps={comboboxProps}
          onDropdownOpen={onDropdownOpen}
          onDropdownClose={onDropdownClose}
          onChange={(value, option) => {
            field.onChange(value);

            if (onValueChange) {
              onValueChange(value, option);
            }
          }}
        />
      )}
    />
  );
};

export default RHFSelect;